import React from 'react'
import './DeclineModal.css'
import closeIcon from '../Assets/Icons/close.png'

export default function DeclineModal({ setOpen, onConfirm, guestName }) {
    const handleConfirm = () => {
        onConfirm()
        setOpen(false)
    }

    return (
        <div className="decline-modal-overlay">
            <div className="decline-modal-content">
                <img
                    src={closeIcon}
                    alt="Close"
                    className="decline-modal-close"
                    onClick={() => setOpen(false)}
                />

                <h3 className="decline-modal-title">
                    Are you sure you want to decline this invitation?
                </h3>

                {guestName && (
                    <p className="decline-modal-guest-name">
                        Declining for: {guestName}
                    </p>
                )}

                <p className="decline-modal-message">
                    We're sorry you won't be able to join the celebration. If you're sure you'd like to decline, please confirm.
                </p>

                <button
                    onClick={handleConfirm}
                    className="decline-confirm-btn"
                >
                    Yes, decline invitation
                </button>
            </div>
        </div>
    )
}

